import { EditorBlockGroup } from '@app/components/cms/blockGroup';
import { HoverToolsContextProvider } from '@app/components/cms/context/HoverToolsContext';
import { isEmpty } from '@app/utils/isEmpty';
import { Cms } from '@typings';
import cx from 'classnames';
import React from 'react';

import { getSectionClassnames } from './getSectionClassnames';
import styles from './section.module.scss';
import { SectionEmptyState } from './SectionEmptyState';
import { SectionTools } from './SectionTools';
import { SectionWarnings } from './SectionWarnings';

interface Props {
  sectionData: Cms.Section;
  className?: string;
  shouldHideTools?: boolean;
}

export const EditorSection = React.memo((props: Props) => {
  const { sectionData, className } = props;
  const { visibleFor, id, groupsOrder } = sectionData;

  const shouldShowEmptyState = isEmpty(groupsOrder);
  const sectionClassNames = getSectionClassnames(visibleFor);
  const classNames = cx(styles.section, sectionClassNames, styles.withTools, className);

  return (
    <HoverToolsContextProvider>
      <div id={sectionData.id} className={classNames}>
        <SectionWarnings sectionData={sectionData} />
        <SectionTools sectionData={sectionData} />
        {groupsOrder.map((key, index) => (
          <EditorBlockGroup key={key} groupId={key} sectionId={id} groupIndex={index} />
        ))}
        {shouldShowEmptyState && <SectionEmptyState sectionId={sectionData.id} />}
      </div>
    </HoverToolsContextProvider>
  );
});
